import { cx } from '@apparel/react/cx';
import Button from '@material-ui/core/Button';
import MUILink from '@material-ui/core/Link';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { useFormikContext } from 'formik';
import React, { forwardRef, useCallback, useEffect } from 'react';
import { AuthViewType } from '../../AuthButtonProps';
import { useNewAuthForm } from '../NewAuthFormContext';
import { useNewAuthDialogFormStyles } from './atoms';
import { FormHeader } from './FormHeader';

/**
 *
 * @author: Dumitrana Alinus <alinus@wooter.co>
 * @component: ForgotPassword
 * @date: 24.01.2021
 * @time: 05:59
 */
export const ForgotPassword = forwardRef(({ className, ...rest }: React.HTMLAttributes<HTMLDivElement>, ref: any) => {
    const classes = useNewAuthDialogFormStyles();
    const dialog$ = useNewAuthForm();
    const { handleChange, setFieldValue, values } =
        useFormikContext<{
            identifier: string;
        }>();

    const handleView = useCallback((view: AuthViewType) => () => dialog$.setView(view), [dialog$.setView]);

    useEffect(() => {
        if (values.identifier) {
            if (!(values.identifier.includes('.') || values.identifier.includes('@'))) {
                setFieldValue('identifier', '');
            }
        }
    }, []);

    return (
        <div className={cx(classes.root, className)} ref={ref} {...rest}>
            <FormHeader />

            <div className={classes.content}>
                <TextField
                    name={'identifier'}
                    value={values.identifier}
                    onChange={handleChange}
                    label={'Email'}
                    placeholder={'email@example.com'}
                    className={classes.field}
                />

                <div className={classes.actions}>
                    <Button
                        type={'submit'}
                        variant={'contained'}
                        color={'primary'}
                        className={classes.button}
                        disableElevation
                    >
                        Submit
                    </Button>
                </div>
            </div>

            <div className={cx(classes.links, 'limit')}>
                <Typography variant={'caption'} color={'textSecondary'}>
                    Don't have an account?
                    <MUILink
                        color={'textPrimary'}
                        variant={'caption'}
                        underline={'always'}
                        onClick={handleView('signUp')}
                    >
                        Sign up
                    </MUILink>
                    <br />
                    or
                    <br />
                    <MUILink
                        color={'textPrimary'}
                        variant={'caption'}
                        underline={'always'}
                        onClick={handleView('signIn')}
                    >
                        Sign In
                    </MUILink>
                    if you already have an account.
                </Typography>
            </div>
        </div>
    );
});

export default ForgotPassword;
